import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fallasFilter',
    pure: false
})
export class FallasFilter implements PipeTransform {
    transform(items: any[], filter: string): any {
        if (filter.length<1) return items;
        
        filter = filter.toLocaleLowerCase();
        return items.filter(item =>  (item.nombre + " " + item.descripcion + " " + item.email + " " + item.categoria + " " + item.identificador + " " + item.precio).toLocaleLowerCase().indexOf(filter) !== -1 );
    }
}